module.exports = __webpack_public_path__ + "media/images/landing_page/circular_credit_card_icon-7f5c2c4f70e9c31841cedfba63cbde1f.png";